import { Request,BaseApiUrl } from "./api";
// 采购合同模块
// 列表
export const getPurchasecontractListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Purchasecontract/get`, { params: params });
};
//编辑
export const editPurchasecontract = (params) => {
  return Request.post(`${BaseApiUrl}/api/Purchasecontract/put`, params);
};
//新增
export const addPurchasecontract = (params) => {
  return Request.post(`${BaseApiUrl}/api/Purchasecontract/post`, params);
};
//获取详情
export const getPurchasecontractDetail = (params) => {
    return Request.get(`${BaseApiUrl}/api/Purchasecontract/Detail`, { params: params });
};
//实际所需基础数据
export const getPurchasecontractBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/Purchasecontract/GetPurchasecontractBaseData`, { params: params });
};

//批量删除
export const batchDeletePurchasecontract = (params) => {
  return Request.post(`${BaseApiUrl}/api/Purchasecontract/BatchDelete`, params);
};
// export const batchDeletePurchasecontract = (params) => {
//   return Request.delete(`${BaseApiUrl}/api/Purchasecontract/BatchDelete`, {
//     data: params,
//     headers: {
//       "Content-Type": "application/json-patch+json",
//     },
//   });
// };
// 历史列表
export const getHistryByPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/Purchasecontract/GetHistry`, { params: params });
};
//归档
export const filedInfo = (params) => {
    return Request.post(`${BaseApiUrl}/api/Purchasecontract/FiledInfo`, params);
  };
  